module.exports = __webpack_public_path__ + "assets/0fecfe16d577349a1c445a76a56f1c85.mp3";


/*****************
 ** WEBPACK FOOTER
 ** C:/Users/timice/Desktop/ROC2/engine/public-src/spingames/panel/sounds/buttons/coins/bet_6.mp3
 ** module id = 43
 ** module chunks = 0
 **/